import backupSchedules from "./backupSchedules.component";
import backupSchedulesUrls from "./backupSchedules.urls";
import BackupSchedulesTransforms from "./backupSchedules.transforms";

const backupSchedulesModule = angular
  .module("app.components.backupSchedules", [])
  .component("backupSchedulesPage", backupSchedules)
  .service("BackupSchedulesTransforms", BackupSchedulesTransforms)
  .config(backupSchedulesUrls);

export default backupSchedulesModule;



// WEBPACK FOOTER //
// ./src/pages/backupSchedules/backupSchedules.module.js